import { render, staticRenderFns } from "./iconInformation.vue?vue&type=template&id=1b141c9e&scoped=true&"
import script from "./iconInformation.vue?vue&type=script&lang=js&"
export * from "./iconInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b141c9e",
  null
  
)

export default component.exports